"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../shared"));

require("./Dropdown.css");

var _DropdownDumb = _interopRequireDefault(require("./DropdownDumb"));

var _DropdownSmart = _interopRequireDefault(require("./DropdownSmart"));

var _DropdownTrigger = _interopRequireDefault(require("./DropdownTrigger"));

var _DropdownContent = _interopRequireDefault(require("./DropdownContent"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Dropdown(_ref) {
  var arrow = _ref.arrow,
      className = _ref.className,
      margin = _ref.margin,
      open = _ref.open,
      defaultOpen = _ref.defaultOpen,
      color = _ref.color,
      trigger = _ref.trigger,
      children = _ref.children,
      position = _ref.position,
      disabled = _ref.disabled,
      padding = _ref.padding,
      onToggle = _ref.onToggle,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["arrow", "className", "margin", "open", "defaultOpen", "color", "trigger", "children", "position", "disabled", "padding", "onToggle"]);

  var allProps = _extends({
    arrow: arrow,
    className: className,
    margin: margin,
    color: color,
    trigger: trigger,
    position: position,
    disabled: disabled,
    onToggle: onToggle,
    padding: padding,
    children: children
  }, otherProps);

  if (open === null) {
    return /*#__PURE__*/_react["default"].createElement(_DropdownSmart["default"], _extends({
      open: defaultOpen
    }, allProps));
  }

  return /*#__PURE__*/_react["default"].createElement(_DropdownDumb["default"], _extends({
    open: open
  }, allProps));
}

Dropdown.propTypes = {
  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** margin for box, if any */
  margin: utils.spacing.marginProps,

  /** whether dropdown is open. Use for uncontrolled dropdown */
  open: _propTypes["default"].bool,

  /** whether dropdown is initially open. Use for controlled component */
  defaultOpen: _propTypes["default"].bool,

  /** label for dropdown trigger */
  trigger: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** position of dropdown content */
  position: _propTypes["default"].oneOf(['left', 'right', 'left-flush', 'right-flush', 'none', 'none-horizontal', 'center']),

  /** display a pointy arrow on one of the side */
  arrow: _propTypes["default"].oneOf(['top-left', 'top-right', 'top']),

  /** color of dropdown trigger */
  color: _propTypes["default"].oneOf(['blurple', 'gray']),

  /** padding for content. Setting this overrides defaults and does not extend them */
  padding: utils.spacing.paddingProps,

  /** whether control should be disabled */
  disabled: _propTypes["default"].bool,

  /** event listener for when dropdown is toggled; passes open state when uncontrolled */
  onToggle: _propTypes["default"].func
};
Dropdown.defaultProps = {
  arrow: null,
  className: null,
  margin: null,
  open: null,
  defaultOpen: null,
  position: 'left',
  color: 'blurple',
  padding: {
    vertical: 'smd',
    horizontal: 'md'
  },
  disabled: false,
  onToggle: function onToggle() {
    return null;
  },
  trigger: null
};
Dropdown.Trigger = _DropdownTrigger["default"];
Dropdown.Content = _DropdownContent["default"];
var _default = Dropdown;
exports["default"] = _default;